<!-- @format -->

<registered-page>
  <div class="wrapper app">
    <section class="form_wrap">
      <div class="form_inner">
        <h1 class="main_title app">解析を受け付けました。</h1>

        <div class="ill_container">
          <img src="/assets/img/common/ill_accept.svg" alt="" />
        </div>

        <p class="accept_txt">
          解析が完了しましたら、ご登録されたアドレス宛にメールにてご連絡いたします。
          <br />
          もうしばらくお待ちください。
          <br />
          また
          <a href="{ routes.makePath('accept-page') }">履歴画面</a>
          からも、解析の進行状況をご確認いただけます。
        </p>

        <ul class="accept_return">
          <li class="accept_return_item">
            <a href="{ state.back }">
              解析画面に戻る
            </a>
          </li>
        </ul>
      </div>
      <!--/.form_inner-->
    </section>
    <!--form_wrap-->
  </div>
  <!--/.wrapper-->
  <enquete-modal
    modal-id="enquete-modal"
  ></enquete-modal>
  <script>
    import di from "dependeny-injection";
    import routes from "@model/routes.js";
    import enqueteModal from "@tags/modal/enquete-modal.riot";

    export default {
      components: { "enquete-modal": enqueteModal },
      onBeforeMount() {
        this.routes = routes;
        this.state.back = location.href.replace(/(\/[^\/]+)$/, "");
      },
      onMounted(){
        if (! di.userStatusApi.getEnquete() ) {
          window.$(this.$('#enquete-modal')).fadeIn(100);
        };
      }
    };
  </script>
</registered-page>
